import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getRouteMetaConfig } from "../../helpers/RouteMetaConfig";

/**
 * RouteMetaTags Component
 * Automatically updates meta tags based on the current route
 * Place this component inside BrowserRouter to enable automatic meta tag updates
 */
const RouteMetaTags = () => {
  const location = useLocation();

  useEffect(() => {
    const metaConfig = getRouteMetaConfig(location.pathname);
    const isKnownRoute = location.pathname === "/" || getRouteMetaConfig(location.pathname) !== getRouteMetaConfig("/");

    // Update document title
    document.title = metaConfig.title;

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", metaConfig.description);
    }

    // Update keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords && metaConfig.keywords) {
      metaKeywords.setAttribute("content", metaConfig.keywords);
    }

    // Update Open Graph title
    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", metaConfig.ogTitle || metaConfig.title);
    }

    // Update Open Graph description
    const ogDescTag = document.querySelector('meta[property="og:description"]');
    if (ogDescTag) {
      ogDescTag.setAttribute("content", metaConfig.ogDescription || metaConfig.description);
    }

    // Update Open Graph URL
    const ogUrlTag = document.querySelector('meta[property="og:url"]');
    if (ogUrlTag) {
      const fullUrl = `https://letsplaybingo.io${location.pathname}`;
      ogUrlTag.setAttribute("content", fullUrl);
    }

    // Update Twitter title
    const twitterTitleTag = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitleTag) {
      twitterTitleTag.setAttribute("content", metaConfig.ogTitle || metaConfig.title);
    }

    // Update Twitter description
    const twitterDescTag = document.querySelector('meta[property="twitter:description"]');
    if (twitterDescTag) {
      twitterDescTag.setAttribute("content", metaConfig.ogDescription || metaConfig.description);
    }

    // Update Twitter URL
    const twitterUrlTag = document.querySelector('meta[property="twitter:url"]');
    if (twitterUrlTag) {
      const fullUrl = `https://letsplaybingo.io${location.pathname}`;
      twitterUrlTag.setAttribute("content", fullUrl);
    }

    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    // For 404s (unknown routes), canonical should point to home page
    const canonicalPath = isKnownRoute ? location.pathname : "/";
    const fullUrl = `https://letsplaybingo.io${canonicalPath}`;
    canonicalLink.setAttribute("href", fullUrl);
  }, [location]);

  return null;
};

export default RouteMetaTags;
